import React from "react";
import SaitButton from "../atomic/SaitButton";
import NomeFileExcel from "../template/NomeFileExcel";
import PivotTableChartIcon from "@mui/icons-material/PivotTableChart";
import { IconButton } from "@mui/material";

export default function GridToolbarFilterButton(props) {
	const [openPivot, setOpenPivot] = React.useState(false);

	return (
		<>
			<NomeFileExcel
				open={openPivot}
				close={() => setOpenPivot(false)}
				exportFunction={props.pivotFunction}
				exportParams={{
					rowCount: props.rowCount,
					columns: props.columns,
					columnsVisibility: props.columnsVisibility,
					fetchDataForExcel: props.fetchDataForExcel,
				}}
			/>
			{props.toolbarIcons ? (
				<IconButton loading={props.isFiltering} onClick={() => setOpenPivot(true)} disabled={props.rows.length === 0}>
					<PivotTableChartIcon color="primary" />
				</IconButton>
			) : (
				<SaitButton text={"Pivot"} loading={props.isFiltering} onClick={() => setOpenPivot(true)} startIcon={<PivotTableChartIcon />} variant="text" disabled={props.rows.length === 0} />
			)}
		</>
	);
}
